varying float vAngle;
varying vec4 vColour;

uniform sampler2D map;

void main() {
  vec2 uv = gl_PointCoord.xy;

  float c = cos(vAngle);
  float s = sin(vAngle);
  mat2 r = mat2(c, s, -s, c);
  uv = (uv - 0.5) * r + 0.5;

  // Soft circular mask (in addition to texture alpha)
  vec2 d = uv - 0.5;
  float dist = length(d);
  float mask = smoothstep(0.5, 0.2, dist);

  vec4 texel = texture2D(map, uv);
  // if (texel.a < 0.6) discard;
  texel.a = smoothstep(0.07, 0.87, texel.a);

  vec4 col = vColour;
  col.a *= mask;
  col.a *= texel.a;
  col.rgb *= 5.5;

  if (col.a < 0.2) discard;

  gl_FragColor = col;
}


